import { styled } from '@mui/material';
import { useAnimation, motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { BrandclubThreeSpotlightWidget } from '../components/BrandclubThreeSpotlightWidget/index.js';

var HowItWorksTileImg = styled('div')({
    overflow: 'hidden',
    width: 290,
    height: 290,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    '.img_bg': {
        width: 250,
        position: 'absolute',
        height: 250,
        backgroundColor: 'grey',
    },
    '.tophalf': {
        width: 290,
        height: 145,
        position: 'relative',
        overflow: 'hidden',
        ':after': {
            content: "''",
            position: 'absolute',
            top: 20,
            left: 20,
            width: 250,
            height: 250,
            borderRadius: '100%',
            boxShadow: '0px 0px 0px 250px #fff',
        },
    },
    '.bothalf': {
        width: 290,
        height: 145,
        position: 'relative',
        overflow: 'hidden',
        ':after': {
            content: "''",
            position: 'absolute',
            top: -125,
            left: 20,
            width: 250,
            height: 250,
            borderRadius: '100%',
            boxShadow: '0px 0px 0px 250px #fff',
        },
    },
    '.prevImg': {
        height: '100%',
        position: 'absolute',
    },
});
var DownloadImg = function () {
    var controls = useAnimation();
    var _a = useInView(), ref = _a[0], inView = _a[1];
    useEffect(function () {
        if (inView) {
            controls.start('visible');
        }
    }, [controls, inView]);
    return (React.createElement(HowItWorksTileImg, null,
        React.createElement("div", { className: "img_bg", style: { backgroundColor: '#FFC5C566' } }),
        React.createElement("div", { className: "tophalf" }),
        React.createElement("div", { className: "bothalf" }),
        React.createElement(motion.img, { ref: ref, animate: controls, initial: "hidden", transition: { duration: 1, ease: 'easeInOut' }, variants: {
                visible: { opacity: 1, rotate: 0, scale: 1 },
                hidden: { opacity: 0, rotate: 20, scale: 0.5 },
            }, alt: "download", src: "https://media.brandclub.com/brandclub/image_asset/teach_download.png", className: "prevImg" })));
};
var ShopImg = function () {
    var controls = useAnimation();
    var _a = useInView(), ref = _a[0], inView = _a[1];
    useEffect(function () {
        if (inView) {
            controls.start('visible');
        }
    }, [controls, inView]);
    return (React.createElement(HowItWorksTileImg, null,
        React.createElement("div", { className: "img_bg", style: { backgroundColor: '#E5E5E566' } }),
        React.createElement("div", { className: "tophalf" }),
        React.createElement("div", { className: "bothalf" }),
        React.createElement(React.Fragment, null,
            React.createElement(motion.img, { ref: ref, animate: controls, initial: "hidden", transition: { duration: 1, ease: 'easeInOut' }, variants: {
                    visible: { opacity: 1, scale: 1, rotate: 0 },
                    hidden: { opacity: 0, scale: 0.5, rotate: 80 },
                }, alt: "cash", src: "https://media.brandclub.com/brandclub/image_asset/teach_amazon.png", className: "prevImg" }),
            React.createElement(motion.img, { ref: ref, animate: controls, initial: "hidden", transition: { duration: 1, ease: 'easeInOut' }, variants: {
                    visible: { opacity: 1, scale: 1, rotate: 0 },
                    hidden: { opacity: 0, scale: 0.5, rotate: 80 },
                }, alt: "cash", src: "https://media.brandclub.com/brandclub/image_asset/teach_walmart.png", className: "prevImg" }),
            React.createElement(motion.img, { ref: ref, animate: controls, initial: "hidden", transition: { duration: 1, ease: 'easeInOut' }, variants: {
                    visible: { opacity: 1, scale: 1, rotate: 0 },
                    hidden: { opacity: 0, scale: 0.5, rotate: 80 },
                }, alt: "cash", src: "https://media.brandclub.com/brandclub/image_asset/teach_target.png", className: "prevImg" }))));
};
var CashBackImg = function () {
    var controls = useAnimation();
    var _a = useInView(), ref = _a[0], inView = _a[1];
    useEffect(function () {
        if (inView) {
            controls.start('visible');
        }
    }, [controls, inView]);
    return (React.createElement(HowItWorksTileImg, null,
        React.createElement("div", { className: "img_bg", style: { backgroundColor: '#4E74D066' } }),
        React.createElement("div", { className: "tophalf" }),
        React.createElement(motion.img, { ref: ref, animate: controls, initial: "hidden", transition: { duration: 1, ease: 'easeInOut' }, variants: {
                visible: { opacity: 1, y: 0 },
                hidden: { opacity: 0, y: 100 },
            }, alt: "cash", src: "https://media.brandclub.com/brandclub/image_asset/teach_cash.png", className: "prevImg" }),
        React.createElement("div", { className: "bothalf" })));
};
var BrandclubHowItWorks = function (_a) {
    var _b, _c;
    var brandEntity = _a.brandEntity;
    var spotlight1 = {
        title: 'Download Brandclub',
        subtitle: "Download the Brandclub app to join the ".concat((_b = brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) === null || _b === void 0 ? void 0 : _b.name, " rewards program."),
        ImgWidget: function () { return React.createElement(DownloadImg, null); },
    };
    var spotlight2 = {
        title: 'Shop and engage',
        subtitle: "Earn cash rewards when you buy ".concat((_c = brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) === null || _c === void 0 ? void 0 : _c.name, " products from your favorite retailers."),
        ImgWidget: function () { return React.createElement(ShopImg, null); },
    };
    var spotlight3 = {
        title: 'Get cash back',
        subtitle: 'Earn real cash. No confusing point systems or gift cards.',
        ImgWidget: function () { return React.createElement(CashBackImg, null); },
    };
    return (React.createElement(BrandclubThreeSpotlightWidget, { header: "How it works", spotlight1: spotlight1, spotlight2: spotlight2, spotlight3: spotlight3, showStarts: true }));
};

export { BrandclubHowItWorks };
//# sourceMappingURL=index.js.map
